module.exports = __webpack_public_path__ + "static/videoofertasEN-e9f91590bd4be621e9b03610e70ff140.png";